import CryptoJS from 'crypto-js';

const passkey = 'kfsysccdjiwoqdrefrg'

/**
 * 將 ID 加密存於 localStorage
 * @param {String} value 
 */
const saveID = (value) => {
  localStorage.setItem('id', encode(value))
}

const encode = (uid) => {
  return CryptoJS.AES.encrypt(uid, passkey).toString()
}

/**
 * 解密儲存於 localStorage 的 ID 並傳回 value
 */
const loadID = () => {
  const uid_enc = localStorage.getItem('id')
  return uid_enc === null ? '' : decode(uid_enc)
}

const decode = (uid_enc) => {
  return CryptoJS.AES.decrypt(uid_enc, passkey).toString(CryptoJS.enc.Utf8)
}

export { saveID, loadID }



// WEBPACK FOOTER //
// ./src/util/idCrypto.js